import React from 'react';
import { Modal } from '@mui/material';
import { AddSchoolModalProps } from './types/school';

import { ModalBox } from './styled';
import AddSchoolForm from './AddSchoolForm';
import EditSchoolForm from './EditSchoolForm';

const SchoolModal = ({
  open,
  onClose,
  setSnackbar,
  modalType,
  schoolId
}: AddSchoolModalProps) => {
  const handleClose = () => {
    onClose();
  };
  return (
    <Modal open={open} onClose={handleClose}>
      <ModalBox style={{ height: modalType === 'edit' ? 'auto' : 600 }}>
        {modalType === 'add' && (
          <AddSchoolForm
            handleModalClose={handleClose}
            setSnackbar={setSnackbar}
          />
        )}
        {modalType === 'edit' && schoolId && (
          <EditSchoolForm
            handleModalClose={handleClose}
            setSnackbar={setSnackbar}
            schoolId={schoolId ?? ''}
          />
        )}
      </ModalBox>
    </Modal>
  );
};

export default SchoolModal;
